module.exports = __webpack_public_path__ + "img/38.72d07a42.jpg";